import React from "react";
import { motion } from "framer-motion";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Whoarewe.css";

const WhoWeAre = () => {
  const reveal = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.2, 1, 0.3, 1] } },
  };

  return (
    <div className="who-page">
      <TopBar />
      <Navbar />

      {/* --- PREMIUM HERO SECTION --- */}
      <section className="who-hero-modern">
        <div className="hero-grid">
          <motion.div initial="hidden" animate="visible" className="hero-left">
            <motion.span variants={reveal} className="hero-tag">ESTABLISHED 1978</motion.span>
            <motion.h1 variants={reveal} className="hero-display">
              The Rift <br /> <span className="blue-glow">Legacy</span>
            </motion.h1>
            <motion.p variants={reveal} className="hero-subtext">
              Rift Nakuru Insurance Agencies Limited is a registered agency 
              providing international standard service to corporate and individual clients.
            </motion.p>
          </motion.div>
          <div className="hero-right">
             <div className="experience-box">
                <span className="exp-num">45+</span>
                <span className="exp-label">Years of Excellence</span>
             </div>
          </div>
        </div>
      </section>

      {/* --- FOUNDERS & AGENCY HISTORY --- */}
      <section className="agency-history">
        <div className="history-container">
          <div className="history-text">
            <h2 className="section-title">Our <span className="blue-text">Agency</span></h2>
            <p className="history-para">
              Founded by <strong>Late Niru Shah</strong> and <strong>Late Haren Shah</strong> in 1978, 
              we are managed by highly experienced personnel committed to outstanding service.
            </p>
            <p className="history-para">
              Our team has deep expertise in providing insurance policies for 
              <strong> Agriculture, Real Estate, Education, Manufacturing,</strong> and <strong>Trading</strong> sectors.
            </p>
          </div>
          
          <div className="ira-badge-container">
            <div className="ira-card">
              <span className="ira-icon">🛡️</span>
              <h3>IRA Registered</h3>
              <p>License renewed up to December 2026</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- MISSION & VISION (Glass Cards) --- */}
      <section className="mission-vision-area">
        <div className="philosophy-grid">
          <motion.div className="philosophy-card" whileHover={{ scale: 1.02 }}>
            <span className="card-type">MISSION</span>
            <p>"Providing exceptional insurance solutions through comprehensive risk assessments and dedicated customer service."</p>
          </motion.div>
          
          <motion.div className="philosophy-card dark" whileHover={{ scale: 1.02 }}>
            <span className="card-type">VISION</span>
            <p>"To be the leading provider of insurance solutions in the region, ensuring the best possible coverage."</p>
          </motion.div>
        </div>
        
        <div className="motto-banner">
          <h3>MOTTO: <span className="italic-serif">"Securing your future"</span></h3>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WhoWeAre;